import React, { FC } from 'react'
import { Button, Modal } from 'UI'
import { ModalHeight, ModalSize } from 'UI/Modal/types'
import { ButtonStyles } from 'UI/Button/types'
import { useDisableScrollManual } from 'hooks/useDisableScrollManual'
import { useNavigate } from 'react-router-dom'
import cl from './style.module.scss'

interface ArchiveModalProps {
	isOpen: boolean
	courseTitle: string
	onClose: () => void
}

const ArchiveModal: FC<ArchiveModalProps> = ({
	isOpen,
	courseTitle,
	onClose
}) => {
	const navigate = useNavigate()
	useDisableScrollManual(isOpen)
	return (
		<Modal
			onClose={onClose}
			isOpen={isOpen}
			styleTypes={[ModalSize.BIG, ModalHeight.SMALL]}
			title="Курс перенесен в архив"
			description={`Вы можете найти курс "${courseTitle}" в разделе "Архивные" `}
		>
			<div className={cl.buttonsContainer}>
				<Button
					onClick={() => {
						navigate('/')
						onClose()
					}}
					styleTypes={[ButtonStyles.DARK, ButtonStyles.ROUND]}
				>
					Перейти к списку курсов
				</Button>
			</div>
		</Modal>
	)
}

export default ArchiveModal
